import { takeLatest, put, call } from 'redux-saga/effects';

import { isNil, reject } from 'ramda';
import { toastr } from 'react-redux-toastr';
// import { I18n } from 'src/translations/i18n';
import { I18n } from 'src/translations/i18n';

import toastrError from 'src/helpers/toastr/toastrError';
import Utils from 'src/utils';
import { lawChecksActions } from 'src/store/reducers/lawChecksReducer';
import { wtsApi } from 'src/api';

// eslint-disable-next-line func-names
export default function* () {
  yield takeLatest(lawChecksActions.request, lawChecksRequestSaga);
}

function* lawChecksRequestSaga({ payload }) {
  try {
    const {
      userIds,
      period,
      paragraphs,
      ...other
    } = payload;

    const params = {
      ...other,
      userIds: userIds ? userIds.join(',') : null,
      period: Utils.periods.formatPeriod(period),
      verifiables: paragraphs
    };

    const response = yield call(wtsApi.verifications.verificationsList, reject(isNil, params));

    const data = lawChecksResponseParse(response);

    if (!data.length) {
      toastr.warning(I18n.t('NoDataAvailable'));
    }

    yield put({
      type: lawChecksActions.success,
      payload: data
    });
  } catch (e) {
    toastrError(e);
    yield put({
      type: lawChecksActions.fail,
      payload: e.message
    });
  }
}

const lawChecksResponseParse = ({ data }) => {
  const {
    ResultId,
    Data
  } = data;

  if (ResultId !== 0) return null;

  return Data;
};
